import { render } from "./TokensTable.vue?vue&type=template&id=0db03666&scoped=true"
import script from "./TokensTable.vue?vue&type=script&lang=js"
export * from "./TokensTable.vue?vue&type=script&lang=js"

import "./TokensTable.vue?vue&type=style&index=0&id=0db03666&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db03666"]])

export default __exports__